import { z } from 'zod';
import { eventSchema } from './envelope';

export const TASKS_RUN_CREATED_V1 = 'tasks.run.created.v1' as const;
export const TASKS_RUN_COMPLETED_V1 = 'tasks.run.completed.v1' as const;
export const TASKS_RUN_OVERDUE_V1 = 'tasks.run.overdue.v1' as const;
export const TASKS_ITEM_DEVIATION_V1 = 'tasks.item.deviation.v1' as const;

/**
 * Er staat een checklist klaar.
 *
 * Met de ontvangers erin, in stukken zoals bij een bericht: `notifications` schrijft de inboxregels
 * en kan de doelgroep niet zelf uitrekenen (ADR-0021). Geen itemteksten: wat er afgevinkt moet
 * worden, leest de medewerker in de app.
 */
export const runCreatedV1Schema = eventSchema({
  runId: z.guid(),
  templateId: z.guid(),
  templateName: z.string(),
  dueAt: z.string().datetime(),
  recipientIds: z.array(z.guid()),
});
export type RunCreatedV1 = z.infer<typeof runCreatedV1Schema>;

/** Afgerond, met het aantal afwijkingen: dat laatste is wat een teamleider wil zien. */
export const runCompletedV1Schema = eventSchema({
  runId: z.guid(),
  templateId: z.guid(),
  templateName: z.string(),
  completedBy: z.guid(),
  deviations: z.number().int(),
});
export type RunCompletedV1 = z.infer<typeof runCompletedV1Schema>;

/**
 * Te laat.
 *
 * Eén event per checklist en niet per item: "de opstartronde van vanmorgen is niet afgevinkt" is de
 * mededeling, en welke van de twaalf items ontbreekt, staat in de app.
 */
export const runOverdueV1Schema = eventSchema({
  runId: z.guid(),
  templateId: z.guid(),
  templateName: z.string(),
  dueAt: z.string().datetime(),
  remaining: z.number().int(),
});
export type RunOverdueV1 = z.infer<typeof runOverdueV1Schema>;

/**
 * Een waarde buiten de grenzen.
 *
 * Mét de waarde en de grens, want dat is hier de inhoud die telt: "koelcel 9 °C (max 7)" zegt
 * alles, en een melding zonder getal laat iemand de app opzoeken terwijl de koelcel warm staat.
 * Dat is een afwijking van ADR-0038 die klein genoeg is om hier te staan: het gaat over een machine
 * en niet over een persoon.
 */
export const itemDeviationV1Schema = eventSchema({
  runId: z.guid(),
  itemId: z.guid(),
  templateName: z.string(),
  itemLabel: z.string(),
  value: z.string(),
  min: z.number().nullable(),
  max: z.number().nullable(),
  reportedBy: z.guid(),
});
export type ItemDeviationV1 = z.infer<typeof itemDeviationV1Schema>;

export const tasksEventCatalog = {
  [TASKS_RUN_CREATED_V1]: runCreatedV1Schema,
  [TASKS_RUN_COMPLETED_V1]: runCompletedV1Schema,
  [TASKS_RUN_OVERDUE_V1]: runOverdueV1Schema,
  [TASKS_ITEM_DEVIATION_V1]: itemDeviationV1Schema,
} as const;
